
export default {
    start_scale: 0.1,
    end_scale: 2,
    start_opacity: 0.2,
    end_opacity: 0
};
